export default __webpack_public_path__ + "static/media/host_presentation.98a81799.png";